import { Inject, Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { MpsILaravelDefaultResponse } from '../interfaces/mps-responses.interface';
import { MpsOauth2Provider } from '../models/mps-provider.model';
import { mpsEndpoints } from '../mps-endpoints';
import { MpsApiService } from './mps-api.service';

@Injectable({
  providedIn: 'root',
})
export class MpsOauth2Service {
  private _apiService = inject(MpsApiService);

  constructor(@Inject('OAUTH2_PROVIDERS_URL') private _oauth2ProvidersUrl: string) {}

  public fetchToken(id: string): Observable<{ token: string }> {
    return this._apiService.get<MpsILaravelDefaultResponse<{ token: string }>>(mpsEndpoints.token + id).pipe(
      map((response: MpsILaravelDefaultResponse<{ token: string }>) => {
        return response.data;
      })
    );
  }

  public getProviders(): Observable<MpsOauth2Provider[]> {
    return this._apiService.get<MpsILaravelDefaultResponse<MpsOauth2Provider[]>>(this._oauth2ProvidersUrl).pipe(
      map((response: MpsILaravelDefaultResponse<MpsOauth2Provider[]>) => {
        return response.data;
      })
    );
  }

  public refreshToken(provider: string): Observable<{ token: string }> {
    return this._apiService
      .get<MpsILaravelDefaultResponse<{ token: string }>>(mpsEndpoints.refreshToken.replace(':provider', provider))
      .pipe(
        map((response: MpsILaravelDefaultResponse<{ token: string }>) => {
          return response.data;
        })
      );
  }
}
